import React from 'react';
import classnames from 'classnames';
import { bool, string } from 'prop-types';
import { dt } from '../../../helpers/Utils/GetTailwindToken';

const Loader = (props) => {
    const { automationId, loaderClass, keepOverlay, ...attrs } = props;
    const loaderStyles = dt([
        'flex',
        'justify-center',
        'items-center',
        'top-0',
        'right-0',
        'bottom-0',
        'left-0',
        'z-[2]',
        'after:content-[""]',
        'after:opacity-70',
        'after:w-8',
        'after:h-8',
        'after:block',
        'after:rounded-full',
        'after:border-[3px]',
        'after:border-solid',
        'after:border-gray-15',
        'after:border-t-black',
        'after:animate-loaderRotate',
    ]);
    const overlayStyle = keepOverlay
        ? dt(['fixed', 'bg-overlay-60', '!z-[102]'])
        : dt(['absolute']);

    const classNames = classnames(loaderClass, 'loader', loaderStyles, overlayStyle);

    return <div className={classNames} data-automation-id={automationId} {...attrs} />;
};

Loader.propTypes = {
    /**
     * The data-automation-id to apply.
     */
    automationId: string,
    /**
     * Extends the classes that are applied.
     */
    loaderClass: string,
    /**
     * Provides a translucent background with a fixed position to cover the full page.
     */
    keepOverlay: bool,
};

Loader.defaultProps = {
    automationId: null,
    loaderClass: null,
    keepOverlay: false,
};

export default Loader;
